module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('md-tabs', [_c('md-tab', {
    attrs: {
      "md-icon": "home",
      "md-label": "Dashboard"
    }
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-md-11"
  }, [_c('date-range-picker', {
    staticClass: "pull-right",
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": function($event) {
        _vm.viewAssignment('0', '1', '1')
      }
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('b-button', {
    staticClass: "pull-right ml-1",
    staticStyle: {
      "margin-right": "5px",
      "margin-top": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.viewAssignment('0', '1', '1', 'clear')
      }
    }
  }, [_vm._v("Clear")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Container Types")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 text-muted"
  }, [_vm._v("\n                    By No. of Times Repaired\n                  ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart2"
    }
  }, [(_vm.showGraph == true) ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.chartOptionsRefuel,
      "series": _vm.seriesRefuel
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-md-12 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Survey")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 text-muted"
  }, [_vm._v("\n                    By No. of Containers \n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('model-list-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "list": _vm.monthsArry,
      "option-value": "mV",
      "option-text": "mT",
      "placeholder": "Select Month"
    },
    on: {
      "input": function($event) {
        _vm.viewAssignment('0', '1', '1')
      }
    },
    model: {
      value: (_vm.monthName),
      callback: function($$v) {
        _vm.monthName = $$v
      },
      expression: "monthName"
    }
  })], 1), _vm._v(" "), (_vm.showGraph == true) ? _c('div', {
    attrs: {
      "id": "chart1"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.chartOptionsSurvey,
      "series": _vm.seriesSurvey
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-md-12 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Gate-In Gate-Out")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 text-muted"
  }, [_vm._v("\n                    By No. of Containers \n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('model-list-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "list": _vm.monthsArry,
      "option-value": "mV",
      "option-text": "mT",
      "placeholder": "Select Month"
    },
    on: {
      "input": function($event) {
        _vm.viewAssignment('0', '1', '1')
      }
    },
    model: {
      value: (_vm.monthName),
      callback: function($$v) {
        _vm.monthName = $$v
      },
      expression: "monthName"
    }
  })], 1), _vm._v(" "), (_vm.showGraph == true) ? _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.chartOptionsGate,
      "series": _vm.seriesGate
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('div', [_c('b-button', {
    class: _vm.visible ? null : 'collapsed',
    attrs: {
      "variant": "outline-dark",
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("\n                Filters")]), _vm._v(" "), (_vm.veiwVehicleBookingForm.length > 0) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.getReports
    }
  }, [_vm._v("Export as Excel")]) : _vm._e()], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', {
    staticClass: "gutr"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeName,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.transportTypeFilter),
      callback: function($$v) {
        _vm.transportTypeFilter = $$v
      },
      expression: "transportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.typeList,
      "option-value": "tV",
      "option-text": "tT",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.typeFilter),
      callback: function($$v) {
        _vm.typeFilter = $$v
      },
      expression: "typeFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "disabled": _vm.typeFilter == '' && _vm.transportTypeFilter == '' ? true : false,
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search\n                  ")]), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.veiwVehicleBookingForm,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "gateInId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "containerNo",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s((row1.item.containerNo == '' || row1.item.gateInType == 'Empty_Vehicle') ? " --- " : row1.item.containerNo))])]
      }
    }, {
      key: "loginTime",
      fn: function(row12) {
        return [_c('span', [_vm._v(_vm._s(row12.item.loginTime))])]
      }
    }, {
      key: "delaySurveyStatus",
      fn: function(row123) {
        return [(row123.item.delaySurveyStatus == 1) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("Not Completed In 24 Hours")]), _vm._v(" "), _c('br')]) : (row123.item.delaySurveyStatus == 0) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("Survey Pending")])]) : _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("Survey Done")])])]
      }
    }, {
      key: "shippingApproval",
      fn: function(row3) {
        return [_c('span', {
          style: (row3.item.repairCompletedNot == null || row3.item.repairCompletedNot == '' ? {
            'color': 'red'
          } : {
            'color': 'green'
          })
        }, [_vm._v(_vm._s(row3.item.shippingApproval != 'Approved' ? " ---" : row3.item.repairCompletedNot == null || row3.item.repairCompletedNot == '' ? "Pending" : 'Repair Done'))])]
      }
    }, {
      key: "containerStatus",
      fn: function(row32) {
        return [_c('span', {
          style: (row32.item.containerStatus == 1 || row32.item.repairCompletedNot == 'Repair_Done' ? {
            'color': 'green'
          } : {
            'color': 'red'
          })
        }, [_vm._v(_vm._s(row32.item.containerStatus == 1 ? "Completed" : row32.item.repairCompletedNot == "Repair_Done" ? "Ready to Gate Out" : "Pending"))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91dd7faa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/reports/yardReports.vue
// module id = 2800
// module chunks = 0